import { createAsyncActionTypes } from '../utils';

// eslint-disable-next-line import/prefer-default-export
export const GET_CHALLENGE_RESULTS = createAsyncActionTypes(
  'GET_CHALLENGE_RESULTS'
);
